import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, tap } from 'rxjs';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { Azienda, AziendaService } from 'src/app/services/azienda/azienda.service';
import { LicenzeService } from 'src/app/services/licenze/licenze.service';
import { ReportVsmeService } from 'src/app/services/report-vsme/report-vsme.service';
import { TemaService } from 'src/app/services/tema/tema.service';
import { UtenteIncaricatoService } from 'src/app/services/utente/utente-incaricato.service';
import { UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCreaReportVsmeComponent } from './dialog/dialog-crea-report-vsme/dialog-crea-report-vsme.component';

@Component({
  selector: 'app-report-vsme',
  standalone: false,

  templateUrl: './report-vsme.component.html',
  styleUrl: './report-vsme.component.scss',
})
export class ReportVsmeComponent {
  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  private azienda: Azienda | undefined = undefined;
  public isUtenteGo: boolean = false;
  public filtri: Filtri[] = [
    {
      titolo: 'Anno',
      forControlName: 'anno',
      input: 'text',
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    anno: {
      title: 'Anno',
      value: 'anno',
    },
    risultatiImpegni: {
      title: 'Campi Testuali',
      value: (record: any) =>
        (record?.compilazioni?.campi_testuali?.compilati || 0) +
        '/' +
        (record?.compilazioni?.campi_testuali?.totali || 0),
    },
    risultatiAzioni: {
      title: 'Azioni',
      value: (record: any) =>
        (record?.compilazioni?.azioni?.compilati || 0) +
        '/' +
        (record?.compilazioni?.azioni?.totali || 0),
    },
    risultatiKpi: {
      title: 'Kpi',
      value: (record: any) =>
        (record?.compilazioni?.kpi?.compilati || 0) +
        '/' +
        (record?.compilazioni?.kpi?.totali || 0),
    },
    risultatiTabelle: {
      title: 'Tabelle',
      value: (record: any) =>
        (record?.compilazioni?.tabelle?.compilati || 0) +
        '/' +
        (record?.compilazioni?.tabelle?.totali || 0),
    },
    dataUltimaModifica: {
      title: 'Ultima Modifica',
      value: (record: any) => record?.dataUltimaModifica ?? '',
    },
    dataCreazione: {
      title: 'Data Creazione',
      value: (record: any) => record?.dataCreazione ?? '',
    },

    stato: this.utilityService.getColonnaStato(),

    modifica: {
      type: 'button',
      buttonIcon: (record: any) => (this.isPermessoSoloRead(record) ? 'visibility' : 'edit'),
      title: (record: any) => (this.isPermessoSoloRead(record) ? 'Visualizza' : 'Modifica'),
      buttonId: 'modifica',
      buttonMostraSempre: true,
      sortable: false,
    },
    elimina: {
      ...this.utilityService.getColonnaElimina(),
      nascondiButton: this.nascondiBottoneElimina(),
    },
    elimina_by_developer: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina by Developer',
      buttonId: 'elimina_by_developer',
      buttonMostraSempre: false,
      sortable: false,
      nascondiButton: (record: any) => !this.isDeveloper || record.stato === 'BOZZA',
    },
  };

  get isDeveloper() {
    return !!this.utenteService.infoUtente?.isDeveloper;
  }
  public ctrAnniCreati: string[] = [];
  private _subAziendaCorrente: Subscription | undefined;
  private _subTema: Subscription | undefined;

  private readonly utenteIncaricatoService = inject(UtenteIncaricatoService);

  constructor(
    public dialog: MatDialog,
    private readonly utilityService: UtilityService,
    private readonly aziendaService: AziendaService,
    public utenteService: UtenteService,
    private readonly licenzeService: LicenzeService,
    private readonly temaService: TemaService,
    private readonly reportVsmeService: ReportVsmeService,
  ) {
    this.aziendaService.setCodiciNace();
    this.aziendaService.setCodiciPaesi();
  }

  nascondiBottoneElimina() {
    if (this.utenteService.infoUtente?.isDeveloper) {
      return false; //non nascondere
    }
    if (this.utenteService.isPermessoAttivo('DELETE_VSME')) {
      return false;
    }
    return true; //nascondere
  }

  isPermessoSoloRead(record: any) {
    const isEdit = this.utenteService.isPermessoAttivo('EDIT_VSME');
    const isCreate = this.utenteService.isPermessoAttivo('CREATE_VSME');
    const statoArchiviato = record.stato === 'ARCHIVIATO';
    return (!isEdit && !isCreate) || statoArchiviato;
  }

  async ngAfterViewInit() {
    this._subAziendaCorrente = this.aziendaService.aziendaCorrente.subscribe((azienda) => {
      let cambiato = false;

      if (this.azienda && azienda && this.azienda.id !== azienda.id) {
        cambiato = true;
      }

      this.azienda = azienda;

      if (cambiato) {
        this.tabella?.caricaDati();
      }
    });

    this._subTema = this.temaService.temaUpdated.subscribe((tipoInstallazione) => {
      if (tipoInstallazione === 'SOSTENIBILE_GO') {
        this.isUtenteGo = true;
      } else {
        this.isUtenteGo = false;
      }
    });
  }

  ngOnDestroy(): void {
    this._subAziendaCorrente?.unsubscribe();
    this._subTema?.unsubscribe();
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    return this.reportVsmeService.getReportVsme(page, pageSize, ricerca, filters, sortBy).pipe(
      tap((res) => {
        this.ctrAnniCreati = res.content.flatMap((report) => {
          if (report.stato !== 'ARCHIVIATO') {
            return report.anno;
          }
        });
      }),
    );
  };

  /**
   * Metodo di modifica o creazione nuova REPORT_VSME
   * @param record
   */
  crea(record?: any) {
    if (!record) {
      this.spinnerOver.show();

      this.licenzeService.getUserHasLicense('report_vsme').subscribe({
        next: () => {
          this.spinnerOver.hide();
          this.apriDialogCreaReportVsme(record);
        },
        error: (err) => {
          this.spinnerOver.hide();

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message,
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
    } else {
      this.apriDialogCreaReportVsme(record);
    }
  }

  private apriDialogCreaReportVsme(record: any) {
    const dialogCreaReportVsme = this.dialog.open(DialogCreaReportVsmeComponent, {
      data: {
        reportVsme: record,
        ctrAnniCreati: this.ctrAnniCreati,
        integrazioneIA: this.utenteIncaricatoService.isIntegrazioneIA(),
      },
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '80%',
      height: '99%',
      autoFocus: false,
    });

    dialogCreaReportVsme.afterClosed().subscribe((result) => {
      // Ricarica i dati della tabella dopo la chiusura del dialogo
      this.tabella.caricaDati();
    });
  }

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.crea(event.data);
        break;
      case 'elimina':
      case 'archivia':
      case 'disarchivia':
        this._elimina(event.data, false);
        break;

      case 'elimina_by_developer':
        this._elimina(event.data, true);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  /**
   * Gestisce l'eliminazione di un modulo tramite il service `utilityService`.
   * Mostra lo spinner durante l'operazione e aggiorna la tabella al termine.
   *
   * @async
   * @param {any} modulo - L'oggetto modulo da eliminare. Deve contenere almeno l'ID e lo stato.
   *
   */
  async _elimina(modulo: any, deleteByDeveloper: boolean) {
    this.spinnerOver.show();

    const success = await this.utilityService.eliminaModulo(
      modulo,
      this.reportVsmeService,
      deleteByDeveloper,
    );

    this.spinnerOver.hide();

    if (success) {
      this.tabella.caricaDati();
    } else {
      console.log('Operazione annullata o non riuscita');
    }
  }
}
